export const DEFAULT_SPLIT_POINT = 'onboarding';
export const DEFAULT_SPLITTER_PROVIDER = 'internal';
export const DEFAULT_PLATFORM_TYPE = 'web';
export type FlowType = 'Email' | 'General flow';
export type SplitTrafficMode = 'onboarding' | 'payment';
export type SplitterProviderMode = 'internal' | 'eppo';
export type PlatformType = 'web' | 'android' | 'ios' | 'mobile';
export type ScreenFlowType = 'onboarding' | 'payment';

export enum AppLinkPlatform {
    Ios = 'ios',
    Android = 'android',
}

export const FLOW_TYPES = ['onboarding', 'payment'];
export const CATEGORIES_TYPES = ['select', 'info', 'loaders', 'input', 'modals', 'payment_info', 'products', 'checkouts'];
export const QA_EMAILS = ['wellfunnel_aqa@welltech.com'];

export const platformTypes = [
    { name: 'Web', value: 'web' },
    { name: 'Android', value: 'android' },
    { name: 'iOS', value: 'ios' },
];

export const legacyPlatformTypes = [
    { name: 'Mobile', value: 'mobile' },
    { name: 'Web', value: 'web' },
];

export const splitPoints = [
    { name: 'Onboarding', value: 'onboarding' },
    { name: 'Payment', value: 'payment' },
];

export const headerTypes = [
    { name: 'Off', value: 'off' },
    { name: 'Logo left', value: 'logo_left' },
    { name: 'Progress', value: 'progress' },
    { name: 'Sign in', value: 'sign_in' },
    { name: 'Skip', value: 'skip' },
    { name: 'Logo left on the plate', value: 'logo_left_plate' },
    { name: 'Logo centered', value: 'logo_centered' },
    { name: 'Progress redesign', value: 'progress_redesign' },
    { name: 'Logo left with burger menu', value: 'logo_left_burger' },
    { name: 'Progress with burger menu', value: 'progress_burger' },
    { name: 'Progress redesign with burger menu', value: 'progress_burger_redesign' },
];

export const productTag = [
    { name: 'Main', value: 'main' },
    { name: 'Offer', value: 'offer' },
    { name: 'Upsell', value: 'upsell' },
    { name: 'None', value: 'none' },
];
